module.exports = __webpack_public_path__ + "static/media/WorkExperiencePreparationLiteracyandNumeracy.91f1abc2.pdf";